/** Profesor o moderador del curso pueden publicar / editar avisos. */
export const canManageCourseNotices = (user, course, participants = []) => {
    if (!user?._id) return false;

    const uid = String(user._id);
    const teacherId = course?.teacher?._id ?? course?.teacher;
    const moderatorId = course?.moderator?._id ?? course?.moderator;

    if (teacherId && String(teacherId) === uid) return true;
    if (moderatorId && String(moderatorId) === uid) return true;

    const participant = participants.find((p) => String(p._id) === uid);
    return (
        participant?.participantRole === 'profesor'
        || participant?.participantRole === 'moderador'
    );
};
